const imageuploading = bool => {
  return {
    type: "img_uploading",
    bool
  };
};

export default imageuploading;
